import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { REHYDRATE } from 'redux-persist';
import { Cart } from '../models/cart.model';

const initialState: Cart = {
  items: [],
  isLoading: false,
  cartId: null,
  someItemOutOfStock: false,
  syncedBaseline: {},
};

type RefreshCartItemsPayload = Pick<Cart, 'items' | 'cartId' | 'someItemOutOfStock'>;

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    refreshCartData: (state, action: PayloadAction<RefreshCartItemsPayload>) => {
      state.items = action.payload.items ?? [];
      state.cartId = action.payload.cartId;
      state.someItemOutOfStock = action.payload.someItemOutOfStock;
      return state;
    },
    refreshSyncedBaseline: (state, action: PayloadAction<Record<string, number>>) => {
      state.syncedBaseline = action.payload;
      return state;
    },
    fetchingRefresh: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
      return state;
    },
    resetCartStore: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state) => {
      state.isLoading = false;
      if (!state.syncedBaseline) {
        state.syncedBaseline = {};
      }
    });
  },
});

export const CartSlice = cartSlice.actions;
export default cartSlice.reducer;
